import { Input, Label } from '@kmgestao/ui';

import { formatPhoneBR } from '../../../features/leads/index.js';

export interface GenerateProspectLinkFormProps {
  email: string;
  phone: string;
  setEmail: (v: string) => void;
  setPhone: (v: string) => void;
}

/**
 * Sub-view do `GenerateProspectLinkDialog` — formulário inicial com
 * campos email/WhatsApp opcionais antes de gerar o link.
 *
 * Extraído para manter o componente pai ≤ 200 linhas (AGENTS.md §5.1).
 */
export function GenerateProspectLinkForm({
  email,
  phone,
  setEmail,
  setPhone,
}: GenerateProspectLinkFormProps) {
  return (
    <div className="space-y-4">
      <p className="text-xs text-muted-foreground">
        Campos abaixo são <strong>opcionais</strong>: servem só para você reconhecer a submissão na
        lista depois. Não enviam nada automaticamente.
      </p>
      <div className="space-y-2">
        <Label htmlFor="prospect-email">Email do contato</Label>
        <Input
          id="prospect-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="maria@clinica.com.br"
          autoComplete="email"
          inputMode="email"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="prospect-phone">Telefone / WhatsApp</Label>
        <Input
          id="prospect-phone"
          type="tel"
          value={phone}
          onChange={(e) => setPhone(formatPhoneBR(e.target.value))}
          placeholder="(11) 99999-9999"
          autoComplete="tel"
          inputMode="tel"
          maxLength={15}
        />
      </div>
    </div>
  );
}
